"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = void 0;
const agentkeepalive_1 = __importDefault(require("agentkeepalive"));
const HttpsAgent = agentkeepalive_1.default.HttpsAgent;
const axios_1 = __importDefault(require("axios"));
const keepAliveAgent = new agentkeepalive_1.default({
    maxSockets: 160,
    maxFreeSockets: 160,
    timeout: 60000,
    freeSocketTimeout: 30000,
    keepAliveMsecs: 60000
});
const httpsKeepAliveAgent = new HttpsAgent({
    maxSockets: 160,
    maxFreeSockets: 160,
    timeout: 60000,
    freeSocketTimeout: 30000,
    keepAliveMsecs: 60000
});
exports.httpClient = axios_1.default.create({
    httpAgent: keepAliveAgent,
    httpsAgent: httpsKeepAliveAgent
});
